import React from "react"
import { IPunchDocument, IQuestion, IPunchSetRecordDto } from "../../../models"
import { Dialog, FlatButton } from "material-ui"
import LeftArrow from "material-ui/svg-icons/hardware/keyboard-arrow-left"
import RightArrow from "material-ui/svg-icons/hardware/keyboard-arrow-right"
import { grey400 } from "material-ui/styles/colors"
import strings from "../../../localization/strings"
import PunchQuestionAnswerDetailContent from "./PunchQuestionAnswerDetailContent"
import moment from "moment"
import * as timeHelper from "../../../helpers/timeHelper"

interface IProps {
    punchSetRecord: IPunchSetRecordDto
    questions: IQuestion[]
    handleClose(): void
}
interface IState {
    navigate: boolean
    answerPunches: IPunchDocument[]
    punchId: string
}

export default class PunchSetQuestionAnswerNavigationDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        const answerPunches = this.getAnswerPunches(props.punchSetRecord)
        this.state = {
            navigate: false,
            answerPunches,
            punchId: answerPunches[0].Id
        }
    }

    getAnswerPunches(punchSetRecord: IPunchSetRecordDto): IPunchDocument[] {
        const punches = punchSetRecord.PunchOut ? [punchSetRecord.PunchIn, punchSetRecord.PunchOut] : [punchSetRecord.PunchIn]
        return punches.filter(i => (i.Btn1Ids && i.Btn1Ids.length > 0) || (i.Btn2Ids && i.Btn2Ids.length > 0))
    }

    navigate(index) {
        this.setState({ navigate: true }, () => {
            const punch = this.state.answerPunches[index]
            this.setState({
                navigate: false,
                punchId: punch.Id
            })
        })
    }

    render() {
        const indexNum = this.state.answerPunches.findIndex(i => i.Id === this.state.punchId)
        const punch = this.state.answerPunches[indexNum]
        return (
            <Dialog
                modal
                open
                autoScrollBodyContent
                title={strings.formatString(strings.Punch_Questions_for_x, moment(timeHelper.keepConvertUTCToLocal(punch.DateTimeLocal)).format("hh:mma MM/DD/YYYY"))}
                actions={<FlatButton label={strings.Close} primary onClick={this.props.handleClose} />}
                onRequestClose={this.props.handleClose}
            >
                <div style={{ paddingLeft: 45, paddingRight: 45 }}>
                    {!this.state.navigate &&
                        <PunchQuestionAnswerDetailContent
                            imageS3Url={punch.ImageS3Url}
                            btn1Ids={punch.Btn1Ids}
                            btn2Ids={punch.Btn2Ids}
                            questions={this.props.questions}
                        />
                    }
                </div>
                {indexNum !== 0 &&
                    <LeftArrow
                        className="NextPrevExceptionArrow"
                        style={{ width: 60, height: "70%", left: 5, borderRadius: 20, cursor: "pointer", position: "absolute", top: 70, fill: grey400 }}
                        onClick={() => this.navigate(indexNum - 1)}
                    />
                }
                {indexNum !== this.state.answerPunches.length - 1 &&
                    <RightArrow
                        className="NextPrevExceptionArrow"
                        style={{ width: 60, height: "70%", right: 5, borderRadius: 20, cursor: "pointer", position: "absolute", top: 70, fill: grey400 }}
                        onClick={() => this.navigate(indexNum + 1)}
                    />
                }
            </Dialog>
        )
    }
}
